import type { ComponentPropsWithRef } from 'react'
import { cn } from '../../lib/cn'
import s from './CountBadge.module.css'

/**
 * Compteur — la petite pastille chiffrée du prototype (nombre de pièces jointes sur
 * un onglet, compteur d'une vue…). Chasse fixe : deux compteurs côte à côte restent
 * alignés quel que soit le nombre de chiffres.
 */
export type CountBadgeProps = ComponentPropsWithRef<'span'>

export function CountBadge({ className, ...props }: CountBadgeProps) {
  return <span className={cn(s.root, className)} {...props} />
}
